module.exports = __webpack_public_path__ + "img/A.625e538b.jpg";